"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_MOBILE = exports.EMAIL_VALIDATION = exports.DOCUMENT_HEIGHT = exports.DOCUMENT_WIDTH = exports.MENUS = exports.CANVAS_IMAGE_TYPE = exports.VIEW_TYPE = exports.DocumentTypes = exports.TYPE_PREVIEW = exports.TYPE_LINK = exports.TIMELINES = exports.REMOVE_ACTIONS = exports.DOCUMENT_ACTIONS = exports.DATE_FORMAT = exports.ADMIN = exports.AREA_MANAGER = exports.BRANCH_MANAGER = exports.CLIENT = exports.BRANCH = exports.UPGRADE_MODAL_TITLE = exports.REQUEST_ERROR_TITLE = exports.PLATFORM = exports.VAT = void 0;
exports.VAT = 0.15;
exports.PLATFORM = "LETSTRADE";
exports.REQUEST_ERROR_TITLE = "Something went wrong!";
exports.UPGRADE_MODAL_TITLE = "Upgrade Required";
exports.BRANCH = "BRANCH";
exports.CLIENT = "CLIENT";
exports.BRANCH_MANAGER = "BRANCH_MANAGER";
exports.AREA_MANAGER = "AREA_MANAGER";
exports.ADMIN = "ADMIN";
exports.DATE_FORMAT = "DD/MM/YYYY";
exports.DOCUMENT_ACTIONS = [
    {
        label: "Save to Draft",
        value: "Save to Draft",
    },
];
exports.REMOVE_ACTIONS = [
    {
        label: "Imports",
        value: "Imports",
    },
    {
        label: "All Blocks",
        value: "All Blocks",
    },
    {
        label: "All Fillables",
        value: "All Fillables",
    },
];
exports.TIMELINES = [
    {
        label: "1 Week",
        value: "1 Week",
    },
    {
        label: "1 Month",
        value: "1 Month",
    },
    {
        label: "3 Months",
        value: "3 Months",
    },
    {
        label: "1 Year",
        value: "1 Year",
    },
];
exports.TYPE_LINK = "link";
exports.TYPE_PREVIEW = "preview";
var DocumentTypes;
(function (DocumentTypes) {
    DocumentTypes["DOCUMENT"] = "DOCUMENT";
    DocumentTypes["TEMPLATE"] = "TEMPLATE";
})(DocumentTypes = exports.DocumentTypes || (exports.DocumentTypes = {}));
var VIEW_TYPE;
(function (VIEW_TYPE) {
    VIEW_TYPE["MOBILE"] = "mobile";
    VIEW_TYPE["WEBSITE"] = "website";
})(VIEW_TYPE = exports.VIEW_TYPE || (exports.VIEW_TYPE = {}));
exports.CANVAS_IMAGE_TYPE = "image/png";
exports.MENUS = [
    {
        title: "Draft",
        subTitle: "Documents",
        status: "DRAFT",
        amount: 0,
        borderColor: "border-green",
        backgroundColor: "bg-green/20",
    },
    {
        title: "Sent",
        subTitle: "Documents",
        status: "SENT",
        amount: 0,
        borderColor: "border-primary",
        backgroundColor: "bg-primary/20",
    },
    {
        title: "Pending Signatures",
        subTitle: "Documents",
        status: "VIEWED",
        amount: 0,
        borderColor: "border-orange",
        backgroundColor: "bg-orange/20",
    },
    {
        title: "Signing In Progress",
        subTitle: "Documents",
        status: "SIGNING",
        amount: 0,
        borderColor: "border-yellow",
        backgroundColor: "bg-yellow/20",
    },
    // {
    //   title: "To Approve",
    //   subTitle: "Documents",
    //   status: "TO APPROVE",
    //   amount: 0,
    //   borderColor: "border-green",
    // },
    {
        title: "Expired",
        subTitle: "Documents",
        status: "EXPIRED",
        amount: 0,
        borderColor: "border-purple",
        backgroundColor: "bg-purple/20",
    },
    {
        title: "Completed",
        subTitle: "Documents",
        status: "COMPLETED",
        amount: 0,
        borderColor: "border-primary",
        backgroundColor: "bg-primary/20",
    },
];
exports.DOCUMENT_WIDTH = 816 + 816 * 0.2;
exports.DOCUMENT_HEIGHT = 1056 + 1056 * 0.2;
// Comprehensive email validation that matches backend Joi validation
// This regex properly validates email format and catches invalid TLDs like "glabal"
exports.EMAIL_VALIDATION = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
exports.IS_MOBILE = window.innerWidth <= 600 ? true : false;
